import {NgModule} from '@angular/core';
import {EmployeePage} from "./page/overview/employee/employee.page";
import {OrganizationUnitPage} from "./page/overview/organization-unit/organization-unit.page";
import {DepartmentPage} from "./page/overview/department/department.page";
import {OmConfigPage} from "./page/overview/om-config/om-config.page";
import {OM_ENTITY_PROVIDER} from "./om.entity-provider";
import {CoreModule} from "../../core/core.module";
import {OM_TEST_PROVIDERS} from "./test/om-test-definition";


@NgModule({
  declarations: [
    EmployeePage,
    OrganizationUnitPage,
    DepartmentPage,
    OmConfigPage,
  ],
  exports:[
    EmployeePage,
    OrganizationUnitPage,
    DepartmentPage,
    OmConfigPage,
  ],
  imports: [
    CoreModule
  ],
  providers: [OM_ENTITY_PROVIDER, OM_TEST_PROVIDERS]
})
export class OmModule { }
 
 
 
